export class LabelsLang {
    public AddAddressLabel: string;
    public AddEmailLabel: string;
    public AddLabel: string;
    public AddPhoneLabel: string;
    public AddressLabel: string;
    public AfterCurrentTimeLabel: string;
    public AlreadySearchedLabel: string;
    public AndLabel: string;
    public AppointmentAtLabel: string;
    public BackButtonLabel: string;
    public BeforeCurrentTimeLabel: string;
    public CancelButton: string;
    public CityLabel: string;
    public CloseButton: string;
    public ConfirmAppointmentStepLabel: string;
    public ConfirmButton: string;
    public CountryLabel: string;
    public CurrentSelectedSiteLabel: string;
    public CurrentSiteLabel: string;
    public CurrentTimeLabel: string;
    public DateOfBirthLabel: string;
    public DeleteButton: string;
    public DismissButton: string;
    public EditLabel: string;
    public EmailLabel: string;
    public EndTimeLabel: string;
    public ExitButton: string;
    public ExpDateLabel: string;
    public FemaleLabel: string;
    public FirstNameLabel: string;
    public SexAtBirthLabel: string;
    public GenderIdentityLabel: string;
    public PreferredNameLabel: string;
    public PreferredPronounsLabel: string;
    public HealthCardCurpLabel: string;
    public HealthCardNamLabel: string;
    public HealthCardUsaLabel: string;
    public IntervenorLabel: string;
    public LanguageLabel: string;
    public LastNameLabel: string;
    public LoginButton: string;
    public MaleLabel: string;
    public MinutesLabel: string;
    public NextLabel: string;
    public NotificationsLabel: string;
    public OkToContactLabel: string;
    public OrLabel: string;
    public OtherLabel: string;
    public PasswordLabel: string;
    public PhoneExtLabel: string;
    public PhoneExtensionLabel: string;
    public PhoneLabel: string;
    public PreferredAddressLabel: string;
    public PreferredPhoneLabel: string;
    public PrefixLabel: string;
    public RegionDepartmentLabel: string;
    public RegionPostalCodeLabel: string;
    public RegionProvinceLabel: string;
    public RegionStateLabel: string;
    public RegionZipCodeLabel: string;
    public SaveButton: string;
    public SearchAllCountriesAndStatesOrProvincesLabel: string;
    public SelectAppointmentStepLabel: string;
    public SelectAppointmentTypeStepLabel: string;
    public SelectDefaultLanguage: string;
    public SelectLabel: string;
    public SiteLabel: string;
    public SitesLabel: string;
    public StartButton: string;
    public StartTimeLabel: string;
    public StreetAddressLabel: string;
    public SubmitButton: string;
    public ToManualInputModeButton: string;
    public ToScannerInputModeButton: string;
    public TypeLabel: string;
    public UsableLanguagesLabel: string;
    public UserNameLabel: string;
    public PharmacyNameLabel: string;
    public AtLabel: string;
    public AppointmentWithLabel: string;
}


// WEBPACK FOOTER //
// ./src/resources/LabelsLang.ts